import {Component, Inject, OnInit} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import {DiagramJsonHandlerService} from '../../../diagram-data/diagram-json-handler.service';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {TranslateModule} from '@ngx-translate/core';
import {NgIf} from '@angular/common';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import {
  DialogCloseButtonComponent,
  InfoMessageComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent
} from '@q9elements/ui-kit/components';
import {ConfirmPrintDialogData} from './models/confirm-print-dialog-data.interface';

@Component({
  selector: 'app-confirm-print-dialog',
  templateUrl: './confirm-print-dialog.component.html',
  styleUrls: ['./confirm-print-dialog.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatRadioModule,
    MatCheckboxModule,
    NgIf,
    TranslateModule,
    SecondaryButtonComponent,
    DialogCloseButtonComponent,
    InfoMessageComponent,
    PrimaryButtonComponent
  ]
})
export class ConfirmPrintDialogComponent implements OnInit {
  public form: UntypedFormGroup;
  public isPro: boolean;

  constructor(
    private diagramJsonSvc: DiagramJsonHandlerService,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmPrintDialogData,
    private dialogRef: MatDialogRef<ConfirmPrintDialogComponent>
  ) {}

  ngOnInit() {
    this.isPro = this.diagramJsonSvc.isPro();
    this.form = new UntypedFormGroup({
      radio: new UntypedFormControl('landscape'),
      addNames: new UntypedFormControl(true)
    });
  }

  public confirm() {
    this.data.callback({
      watermark: !this.isPro,
      addNames: this.form.get('addNames').value,
      footer: true,
      portrait: this.form.get('radio').value === 'portrait'
    });
    this.dialogRef.close();
  }
}
